<template>
  <section class="userPolicies">
    <h2 class="userPolicies__title">Politicas de usuario</h2>
    <div class="polices-list">
      <UserPolicy v-for="policy in policesByUser" :key="policy._id" :policy="policy" :user="user" @change="onChange" />
    </div>
  </section>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    components: {
      UserPolicy: () => import("../permissions/UserPolicy.vue"),
    },
    computed: {
      ...mapGetters("policies", { policiesDb: "policiesDb" }),
      user: function () {
        return this.$store.state.user.dataUser;
      },
      policesByUser() {
        const roleUser = this.user.role;
        const validationByRole = {
          coordinator: (policyKey) => !["can-edit-profile", "acccess-to-novelties"].includes(policyKey),
          monitor: (policyKey) => policyKey !== "Access-reservations-CMS-fields",
          employee: (policyKey) => ["see-models", "Access-reservations-CMS-fields", "see-models-register", "see-monitors-conference"].includes(policyKey),
          model: () => false,
        };

        const assignRegisterPolicy = this.policiesDb.find(({ key }) => key === "assign-permission-free-private");

        const list = this.policiesDb
          .filter(({ key }) => {
            if (key === "assign-permission-free-private") {
              return false;
            }

            return key === "login-from-any-place" || key === "can-use-autologin-robot" || validationByRole?.[roleUser]?.(key);
          })
          .map((policy) => {
            if (policy.key === "see-from" && assignRegisterPolicy) {
              return {
                ...policy,
                relatedPolicies: {
                  registerTypes: assignRegisterPolicy,
                },
              };
            }

            return policy;
          });

        const seeModelsRegister = list.find((policy) => policy.key === "see-models-register");
        const otherPolicies = list.filter((policy) => policy.key !== "see-models-register");

        return seeModelsRegister ? [seeModelsRegister, ...otherPolicies] : otherPolicies;
      },
    },
    methods: {
      onChange({ policy }) {
        const { status, key } = policy;
        const hasPolice = this.$store.state.user.dataUser.polices.hasOwnProperty(key);

        if (!status && hasPolice) {
          delete this.$store.state.user.dataUser.polices[key];
          this.$store.state.user.numTest++;
          return;
        }
        this.$store.state.user.dataUser.polices[key] = policy;
        this.$store.state.user.numTest++;
      },
    },
  };
</script>

<style lang="scss">
  .userPolicies {
    @include Flex(column, flex-start, flex-start);
    width: 100%;
    gap: $mpadding;
    &__title {
      font-weight: lighter;
      font-size: 24px;
    }
  }
</style>
